import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import { OrganizationSelect } from '../../../shared/OrganizationSelect';
import { Form, Formik } from "formik";
import {
  calculateTotalPriceOnCustomOrder, getCustomOrderProduct, scrollToErrors
} from '../../../../helpers/general';
import { ErrorMessage } from 'formik';
import { CreateOrderSchema } from '../../../../helpers/schemas';
import { ORDER_TYPES, PAGE_CONTEXTS, PRODUCT_GROUPS, CERTIFICATE_USAGE_TYPES } from '../../../../config/constants';
import { getOrganizationDetails as getOrganizationDetailsApi } from '../../../../api/clients/organizations';
import { getUsers as getUsersApi } from '../../../../api/clients/users';
import { CompanyInfo } from './CompanyInfo';
import { Messages } from '../../../layout/Messages/Messages';
import { createOrder } from '../../../../api/orders/orders';
import {
  NOTIFICATION_CREATE_ORDER
} from '../../../../config/notifications';
import { OrderSummary } from './OrderSummary';
import { ROUTE_CLIENT_ORDERS } from '../../../../config/routes';
import { history, store } from '../../../../store/store';
import { ListProductGroups } from './ListProductGroups';
import { hideNotification } from '../../../../store/actions/notification';
import { NOTIFICATION_ERROR } from '../../../../store/actions/types';
import { SelectField } from '../../../shared/SelectField';

function CreateOrderForm(props) {
  const [ showForm, setShowForm ] = useState( true );
  const [ organization, setOrganization ] = useState( null );
  const [ selectedOrganizationWithDetails, setSelectedOrganizationWithDetails ] = useState( null );
  const [ productGroups, setProductGroups ] = useState( [] );
  const [ selectedProductGroups, setSelectedProductGroups ] = useState( [] );
  const [ isSimpleSignature, setIsSimpleSignature ] = useState( null );
  const [ isQualifiedSignature, setIsQualifiedSignature ] = useState( null );
  const [ isCertificate, setIsCertificate ] = useState( null );
  const [ isCertificateWithAuth, setIsCertificateWithAuth ] = useState( null );
  const [ organizationUsers, setOrganizationUsers ] = useState( [] );
  const [ users, setUsers ] = useState( [] );
  const [ usersLoadedForSimple, setUsersLoadedForSimple ] = useState( false );
  const [ usersLoadedForAuth, setUsersLoadedForAuth ] = useState( false );

  useEffect( () => {
    setProductGroups( props.productGroups );

    return () => {
      if (store.getState().notification.type === NOTIFICATION_ERROR) {
        store.dispatch( hideNotification() );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ props.productGroups ] )

  const setVisibleSectionForProductGroup = (productGroup, value, formikProps) => {
    switch (productGroup.name) {
      case PRODUCT_GROUPS.SIMPLE_SIGNATURE.name : {
        setIsSimpleSignature( value );
        formikProps.setFieldValue( 'isSimpleSignature', value );
        if (value) {
          setTimeout( () => {
            let simpleSignaturesContent = document.getElementById( 'simple-signatures-content' );
            if (simpleSignaturesContent) {
              // simpleSignaturesContent.scrollIntoView();
            }
          } );
        } else {
          //reset simpleSignatures Values
          formikProps.setFieldValue( 'simpleSignaturesNumber', 0 );
          formikProps.setFieldValue( 'simpleSignaturesValue', 0 );
          productGroup.products.forEach( item => delete item.selected );
        }
        break;
      }
      case PRODUCT_GROUPS.QUALIFIED_SIGNATURE.name : {
        setIsQualifiedSignature( value );
        formikProps.setFieldValue( 'isQualifiedSignature', value );
        if (value) {
          setTimeout( () => {
            let qualifiedSignaturesContent = document.getElementById( 'create-order-qualified-signatures-content' );
            if (qualifiedSignaturesContent) {
              // qualifiedSignaturesContent.scrollIntoView();
            }
          } );
        } else {
          formikProps.setFieldValue( 'qualifiedSignaturesNumber', 0 );
          formikProps.setFieldValue( 'qualifiedSignaturesValue', 0 );
          productGroup.products.forEach( item => delete item.selected );
        }
        break;
      }
      case PRODUCT_GROUPS.CERTIFICATE.name : {
        setIsCertificate( value );
        formikProps.setFieldValue( 'isCertificate', value );
        if (value) {
          // Load users without simple certificates only once
          if (! usersLoadedForSimple) {
            loadUsersForCertificateType( CERTIFICATE_USAGE_TYPES.SIGNATURE );
          }
          setTimeout( () => {
            let certificatesContent = document.getElementById( 'certificates-content' );
            if (certificatesContent) {
              // certificatesContent.scrollIntoView();
            }
          } );
        } else {
          formikProps.setFieldValue( 'certificatesNumber', 0 );
          formikProps.setFieldValue( 'certificatesValue', 0 );
          formikProps.setFieldValue( 'usersWithCertificate', [] );
          productGroup.products.forEach( item => delete item.selected );
        }
        break;
      }
      case PRODUCT_GROUPS.CERTIFICATE_WITH_AUTH.name : {
        setIsCertificateWithAuth( value );
        formikProps.setFieldValue( 'isCertificateWithAuth', value );
        if (value) {
          // Load users without auth certificates only once
          if (! usersLoadedForAuth) {
            loadUsersForCertificateType( CERTIFICATE_USAGE_TYPES.AUTHENTICATION );
          }
          setTimeout( () => {
            let certificatesWithAuthContent = document.getElementById( 'certificates-with-auth-content' );
            if (certificatesWithAuthContent) {
              // certificatesWithAuthContent.scrollIntoView();
            }
          } );
        } else {
          formikProps.setFieldValue( 'certificatesWithAuthNumber', 0 );
          formikProps.setFieldValue( 'certificatesWithAuthValue', 0 );
          formikProps.setFieldValue( 'usersWithCertificateWithAuth', [] );
          productGroup.products.forEach( item => delete item.selected );
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  const toggleProductGroup = (productGroup, formikProps, method) => {
    let cloneOfSelectedProductGroups = [ ...selectedProductGroups ];

    if (method === 'add') {
      if (productGroup.selected) {
        return;
      }
      productGroup.selected = true;
      cloneOfSelectedProductGroups.push( productGroup.id );
      setVisibleSectionForProductGroup( productGroup, true, formikProps );
    } else {
      if (! productGroup.selected) {
        return;
      }
      productGroup.selected = false;
      setVisibleSectionForProductGroup( productGroup, false, formikProps );

      cloneOfSelectedProductGroups = cloneOfSelectedProductGroups.filter( val => val !== productGroup.id );
    }

    setSelectedProductGroups( cloneOfSelectedProductGroups );
    formikProps.setFieldValue( 'productGroups', cloneOfSelectedProductGroups );
    setProductGroups( [ ...productGroups ] );
  }

  const resetProductGroupsData = (formikProps) => {
    formikProps.setFieldValue( 'simpleSignaturesNumber', 0 );
    formikProps.setFieldValue( 'simpleSignaturesValue', 0 );
    formikProps.setFieldValue( 'qualifiedSignaturesNumber', 0 );
    formikProps.setFieldValue( 'qualifiedSignaturesValue', 0 );
    formikProps.setFieldValue( 'certificatesNumber', 0 );
    formikProps.setFieldValue( 'certificatesValue', 0 );
  }

  const setOrganizationDetails = (response, formikProps) => {
    setSelectedOrganizationWithDetails( response.data );
    formikProps.setFieldValue( 'selectedOrganizationName', response.data.name );
    formikProps.setFieldValue( 'companyName', response.data.name );
    formikProps.setFieldValue( 'companyCui', response.data.cui );
    formikProps.setFieldValue( 'companyCity', response.data.city );
    formikProps.setFieldValue( 'companyCounty', response.data.county );
    formikProps.setFieldValue( 'companyAddressLine1', response.data.address_line_1 );
    formikProps.setFieldValue( 'companyAddressLine2', response.data.address_line_2 ? response.data.address_line_2 : '' );
    formikProps.setFieldValue( 'companyPhone', response.data.phone );
    formikProps.setFieldValue( 'companyRegistryNo', response.data.registry_no ?? '' );
    formikProps.setFieldValue( 'companyCountry', response.data.country );
    resetProductGroupsData( formikProps );
  }

  const getOrganizationDetails = (organizationId, formikProps) => {
    getOrganizationDetailsApi( {
      pagination: {
        page_context: PAGE_CONTEXTS.ORDERS.CREATE_CUSTOM,
      },
      organizationId: organizationId,
      notificationId: '',
    } ).then( response => {
      if (! response || ! response.data) {
        return;
      }

      // Set in formik max number of certificates
      formikProps.setFieldValue( 'maxCertificateNumber', response.data.users.length );
      formikProps.setFieldValue( 'userForPayment', response.data.user_id );
      setOrganizationUsers( response.data.users );
      setUsers( response.data.users );
      setOrganizationDetails( response, formikProps );
    } )
  }

  const loadUsersForCertificateType = (usageType) => {
    if (! organization) {
      return;
    }

    getUsersApi( {
      pagination: {
        for_organization: organization,
        exclude_certificate_usage_type: usageType,
      },
      disablePagination: true,
    } ).then( response => {
      if (! response || ! response.data) {
        return;
      }

      // Update users list with filtered users
      setUsers( response.data );
      setOrganizationUsers( response.data );

      // Mark as loaded
      if (usageType === CERTIFICATE_USAGE_TYPES.SIGNATURE) {
        setUsersLoadedForSimple( true );
      } else if (usageType === CERTIFICATE_USAGE_TYPES.AUTHENTICATION) {
        setUsersLoadedForAuth( true );
      }
    } );
  }

  const createCustomOrder = (values) => {
    let items = [];
    productGroups.forEach( productGroup => {
      switch (productGroup.name) {
        case PRODUCT_GROUPS.SIMPLE_SIGNATURE.name: {
          if (values.isSimpleSignature) {
            let productId = getCustomOrderProduct( productGroup ).id;
            items.push( {
              product_group_id: productGroup.id,
              product_id: productId,
              quantity: values.simpleSignaturesNumber,
              price: values.simpleSignaturesValue
            } );
          }
          break;
        }
        case PRODUCT_GROUPS.QUALIFIED_SIGNATURE.name: {
          if (values.isQualifiedSignature) {
            let productId = getCustomOrderProduct( productGroup ).id;
            items.push( {
              product_group_id: productGroup.id,
              product_id: productId,
              quantity: values.qualifiedSignaturesNumber,
              price: values.qualifiedSignaturesValue
            } );
          }
          break;
        }
        case PRODUCT_GROUPS.CERTIFICATE.name: {
          if (values.isCertificate) {
            let usersWithCertificate = [];
            values.usersWithCertificate.forEach( user => {
              usersWithCertificate.push( {
                userId: user.id
              } );
            } );

            let productId = getCustomOrderProduct( productGroup ).id;
            items.push( {
              product_group_id: productGroup.id,
              product_id: productId,
              quantity: values.certificatesNumber,
              price: values.certificatesValue,
              payload: {
                items: usersWithCertificate
              }
            } );
          }
          break;
        }
        case PRODUCT_GROUPS.CERTIFICATE_WITH_AUTH.name: {
          if (values.isCertificateWithAuth) {
            let usersWithCertificateWithAuth = [];
            values.usersWithCertificateWithAuth.forEach( user => {
              usersWithCertificateWithAuth.push( {
                userId: user.id
              } );
            } );

            let productId = getCustomOrderProduct( productGroup ).id;
            items.push( {
              product_group_id: productGroup.id,
              product_id: productId,
              quantity: values.certificatesWithAuthNumber,
              price: values.certificatesWithAuthValue,
              payload: {
                items: usersWithCertificateWithAuth
              }
            } );
          }
          break;
        }
        default: {
          break;
        }
      }
    } );

    let payload = {
      organization_id: values.organization,
      user_id: values.userForPayment,
      items: items,
      type: values.type,
      billing: {
        name: values.companyName,
        phone: values.companyPhone,
        city: values.companyCity,
        county: values.companyCounty,
        country: values.companyCountry,
        registry_no: values.companyRegistryNo,
        cui: values.companyCui,
        address_line_1: values.companyAddressLine1,
        address_line_2: values.companyAddressLine2,
      }
    };

    createOrder( {
      notificationId: NOTIFICATION_CREATE_ORDER,
      data: {
        organization_id: payload.organization_id,
        user_id: payload.user_id,
        items: payload.items,
        billing: payload.billing,
        type: payload.type,
      }
    } ).then( (data) => {
      if (data.data && data.data.id) {
        history.push( ROUTE_CLIENT_ORDERS );
      }
    } );
  }

  const totalOfAllPackages = (formikProps) => {
    let { values } = formikProps;

    let totalSimpleSignatures, totalQualifiedSignatures, totalCertificates, totalCertificatesWithAuth = 0;
    totalSimpleSignatures = parseFloat( calculateTotalPriceOnCustomOrder( values.simpleSignaturesNumber, values.simpleSignaturesValue ) );
    totalQualifiedSignatures = parseFloat( calculateTotalPriceOnCustomOrder( values.qualifiedSignaturesNumber, values.qualifiedSignaturesValue ) );
    totalCertificates = parseFloat( calculateTotalPriceOnCustomOrder( values.certificatesNumber, values.certificatesValue ) );
    totalCertificatesWithAuth = parseFloat( calculateTotalPriceOnCustomOrder( values.certificatesWithAuthNumber, values.certificatesWithAuthValue ) );
    let total = totalSimpleSignatures + totalQualifiedSignatures + totalCertificates + totalCertificatesWithAuth;

    return `${parseFloat( total ).toFixed( 2 )} ${productGroups.length ? productGroups[0].products[0].currency : 'RON'}`
  }

  const getErrorClass = (formikProps, fieldName) => {
    return formikProps.touched[fieldName] ? formikProps.errors[fieldName] !== undefined ? 'custom-is-invalid' : '' : '';
  }

  return (
    <div className="create-order-form">
      <Formik
        key="create_custom_order"
        initialValues={{
          organization: organization || '',
          userForPayment: '',
          productGroups: selectedProductGroups || [],
          isSimpleSignature: isSimpleSignature,
          simpleSignaturesNumber: 0,
          simpleSignaturesValue: 0,
          isQualifiedSignature: isQualifiedSignature,
          qualifiedSignaturesNumber: 0,
          qualifiedSignaturesValue: 0,
          isCertificate: isCertificate,
          certificatesNumber: 0,
          certificatesValue: 0,
          usersWithCertificate: [],
          maxCertificateNumber: organizationUsers.length || 0,
          isCertificateWithAuth: isCertificateWithAuth,
          certificatesWithAuthNumber: 0,
          certificatesWithAuthValue: 0,
          usersWithCertificateWithAuth: [],
          companyCui: '',
          companyCity: '',
          companyCounty: '',
          companyCountry: '',
          companyAddressLine1: '',
          companyAddressLine2: '',
          companyRegistryNo: '',
          companyPhone: '',
          companyName: '',
          selectedOrganizationName: '',
          type: ORDER_TYPES.BILLABLE.value,
        }}
        validationSchema={CreateOrderSchema}
        validateOnChange={true}
        onSubmit={(values, { setSubmitting }) => {
          setShowForm(false);
          setSubmitting(false);
        }}
      >
        {(formikProps) => {
          scrollToErrors( formikProps, true );

          return (
            <Form className="create-order-form__content">
              <div className="create-order-form__notifications">
                <Messages notificationId={NOTIFICATION_CREATE_ORDER}/>
              </div>
              <div className={`create-order-editor ${! showForm ? 'form-hidden' : ''}`}>

                <div className="row create-order-selection-row">
                  <div className="row align-items-center col-xs-12 col-sm-6 create-order-selection-field">
                    <div className="col-12 col-sm-4 label-form-group">
                      <FormattedMessage
                        id="components.pages.orderManagement.createOrderForm.select_org_text"/>
                    </div>
                    <div className="col-12 col-sm-8">
                      <OrganizationSelect
                        fontAwesome="faBuilding"
                        label="fields.organization"
                        name="organization"
                        value={organization}
                        onChange={(e) => {
                          let selectedOrganization = e.target.value;
                          if (! selectedOrganization) {
                            return;
                          }

                          setOrganization( selectedOrganization );
                          formikProps.setFieldValue( 'organization', selectedOrganization );
                          // Reset users loaded flags when changing organization
                          setUsersLoadedForSimple( false );
                          setUsersLoadedForAuth( false );
                          getOrganizationDetails( selectedOrganization, formikProps );
                        }
                        }
                        organizations={props.organizations}
                        formikProps={formikProps}
                        getErrorClass={getErrorClass}
                      />
                    </div>
                  </div>

                  <div className="row align-items-center col-xs-12 col-sm-6 create-order-selection-field">
                    <div className="col-12 col-sm-4 label-form-group">
                      <FormattedMessage
                        id="components.pages.orderManagement.createOrderForm.order_type"/>
                    </div>
                    <div className="col-12 col-sm-8">
                      <SelectField
                        name="type"
                        className="mb-4"
                        classNamePrefix="ml-0"
                        defaultValue={Object.values( ORDER_TYPES )[0]}
                        options={Object.values( ORDER_TYPES )}
                        onChange={(selectedOrderType) => {
                          if (! selectedOrderType) {
                            return;
                          }

                          formikProps.setFieldValue( 'type', selectedOrderType.value );
                        }
                        }
                        formikProps={formikProps}
                        getErrorClass={getErrorClass}
                      />
                    </div>
                  </div>
                </div>

                <CompanyInfo
                  getErrorClass={getErrorClass}
                  formikProps={formikProps}
                  organization={selectedOrganizationWithDetails}
                  users={users}
                />

                <ListProductGroups
                  productGroups={productGroups}
                  toggleProductGroup={toggleProductGroup}
                  formikProps={formikProps}
                  getErrorClass={getErrorClass}
                  isSimpleSignature={isSimpleSignature}
                  isQualifiedSignature={isQualifiedSignature}
                  isCertificate={isCertificate}
                  isCertificateWithAuth={isCertificateWithAuth}
                  users={organizationUsers}
                  organization={selectedOrganizationWithDetails}
                />
                <Messages
                  color="danger"
                  formikProps={formikProps}
                  class="small-field-error"
                  showDismiss={false}
                >
                  <ErrorMessage
                    name="productGroups"
                    component="div"
                    data-testid="errors-productGroups"
                    className="field-error"
                  />
                </Messages>
                <div
                  className="row justify-content-end ml-5 create-order-total-val create-order-grand-total">
                  <FormattedMessage
                    id="components.pages.orderManagement.selectProductGroup.simple_signatures.total"/> {totalOfAllPackages( formikProps )}
                  <span className="vat-text">(<FormattedMessage
                    id="components.pages.orderManagement.vat_included"/>)</span>
                </div>
                <div className="row justify-content-center mt-5 create-order-actions">
                  <Button
                    className="btn-warning"
                    color="primary"
                    size="xl"
                    type="submit"
                  >
                    <FormattedMessage
                      id="components.pages.orderManagement.orderForm.summary"/>
                  </Button>
                </div>
              </div>
              {! showForm && <OrderSummary
                organization={selectedOrganizationWithDetails}
                formikProps={formikProps}
                setShowForm={() => {
                  store.dispatch( hideNotification() );
                  setShowForm( true )
                }}
                productGroups={productGroups}
                totalOfAllPackages={totalOfAllPackages}
                createCustomOrder={createCustomOrder}
              />
              }
            </Form>
          );
        }}
      </Formik>
    </div>
  )
};

export { CreateOrderForm };
